<div class="">
    <div class="header-text-editor sws-border" [class.selected]="isSelected">
        <h4 class="header-text">{{bodyType === blockType.Text ? 'Header Text Editor' : 'Body Text Editor'}}</h4>
        <div class="font-selecters">
        </div>
        <div class="header-editor-wrapper" #editorWrapper>
            <kendo-editor 
                #kendoEditor
                [(value)]="editorContent"
                (valueChange)="onEditorChange($event)"
                [style.height.px]="200">
            </kendo-editor>
        </div>
    </div>
</div>
